import Navbar from './Navbar';
import sbiLogo from '../Images/bosa-insurance-logo.png';
import './ThankYouPage.css';
import { useSelector } from 'react-redux';

function ThankYouPage() {
  const store=useSelector(state=>state)

    function handleDownloadClick(){
     
        const link = document.createElement('a');
        link.href = store.form.downloadPath;
        link.download = 'output_20240605_231738.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };
    
    return (
        <>
        
        <div className="thank-you-page">
         <h1>Thank You!</h1>
           <p>Your form has been submitted successfully.</p>
            <button onClick={handleDownloadClick}  className="download-button" download>
               Download Your File
            </button>
         </div>
        
        </>
    );
}

export default ThankYouPage;
